import { getSubscriptions } from "@/api/billing";
import { SubscriptionPlan } from "@boxem/core-api-schema";

import React, { createContext, useContext, useEffect, useState } from "react";

const SubscriptionContext = createContext(undefined);

interface SubscriptionContextData {
  isFetchingSubscriptions: boolean;

  accountManagementUrl: string;
  setAccountManagementUrl: (url: string[]) => void;

  subscription: SubscriptionPlan | null;
  setSubscription: (subscription: SubscriptionPlan) => void;

  refetchSubscription: () => Promise<SubscriptionPlan | null>;
}

export const useSubscriptionContext = () => useContext<SubscriptionContextData>(SubscriptionContext);

export const SubscriptionContextProvider = (props: { children: React.ReactNode }) => {
  const [accountManagementUrl, setAccountManagementUrl] = useState<string>("");
  const [subscription, setSubscription] = useState<SubscriptionPlan | null>(null);
  const [isFetchingSubscriptions, setIsFetchingSubscriptions] = useState<boolean>(true);

  const refetchSubscription = async () => {
    setIsFetchingSubscriptions(true);

    try {
      const data = await getSubscriptions();

      setAccountManagementUrl(data.accountManagementUrl);
      setSubscription(data.subscription ?? null);

      return data.subscription;
    } catch (e) {
      console.error(e);
    } finally {
      setIsFetchingSubscriptions(false);
    }
  };

  return (
    <SubscriptionContext.Provider
      value={{
        isFetchingSubscriptions,

        accountManagementUrl,
        setAccountManagementUrl,

        subscription,
        setSubscription,

        refetchSubscription,
      }}
    >
      {props.children}
    </SubscriptionContext.Provider>
  );
};
